import { render } from "./MsgLeftNav.vue?vue&type=template&id=3dbf018e&scoped=true"
import script from "./MsgLeftNav.vue?vue&type=script&lang=js"
export * from "./MsgLeftNav.vue?vue&type=script&lang=js"

import "./MsgLeftNav.vue?vue&type=style&index=0&id=3dbf018e&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf018e"]])

export default __exports__